var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcPeoplesOutlineBigCircle64Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 32C0 14.3269 14.3269 0 32 0C49.6731 0 64 14.3269 64 32C64 49.6731 49.6731 64 32 64C14.3269 64 0 49.6731 0 32Z",
    fill: "#0033AD",
    fillOpacity: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.75 33.5C36.95 33.5 34.145 34.01 32 35C29.855 33.995 27.05 33.5 25.25 33.5C21.995 33.5 15.5 35.12 15.5 38.375V42.5H48.5V38.375C48.5 35.12 42.005 33.5 38.75 33.5ZM32.75 40.25H17.75V38.375C17.75 37.565 21.59 35.75 25.25 35.75C28.91 35.75 32.75 37.565 32.75 38.375V40.25ZM46.25 40.25H35V38.375C35 37.685 34.7 37.085 34.22 36.545C35.54 36.095 37.16 35.75 38.75 35.75C42.41 35.75 46.25 37.565 46.25 38.375V40.25ZM25.25 32C28.145 32 30.5 29.645 30.5 26.75C30.5 23.855 28.145 21.5 25.25 21.5C22.355 21.5 20 23.855 20 26.75C20 29.645 22.355 32 25.25 32ZM25.25 23.75C26.9 23.75 28.25 25.1 28.25 26.75C28.25 28.4 26.9 29.75 25.25 29.75C23.6 29.75 22.25 28.4 22.25 26.75C22.25 25.1 23.6 23.75 25.25 23.75ZM38.75 32C41.645 32 44 29.645 44 26.75C44 23.855 41.645 21.5 38.75 21.5C35.855 21.5 33.5 23.855 33.5 26.75C33.5 29.645 35.855 32 38.75 32ZM38.75 23.75C40.4 23.75 41.75 25.1 41.75 26.75C41.75 28.4 40.4 29.75 38.75 29.75C37.1 29.75 35.75 28.4 35.75 26.75C35.75 25.1 37.1 23.75 38.75 23.75Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPeoplesOutlineBigCircle64Px);
export default __webpack_public_path__ + "static/media/ic_peoples_outline_big_circle-64px.9ccd1fb9d6e0c6b8b529ea59d9829472.svg";
export { ForwardRef as ReactComponent };